export default "__VITE_ASSET__CWXB2i$l__"